import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    TOGGLE_OPEN_FILTER_BLOCK_BY_BUTTON,
    TOGGLE_OPEN_FILTER_BLOCK_BY_MOUSE,
} from "../actions/actionTypes";
import {getFromLocalStorage, setToLocalStorage} from "../utils/localStorageUtils";
import {LOCAL_STORAGE_IS_FILTERS_OPEN} from "../utils/constants";

const STORAGE_PERIOD_IN_HOURS = 365 * 24;

export default function usePageFiltersOpenState() {
    const dispatch = useDispatch();
    const isOpenByHover = useSelector((state) => state.navigationReducer.isFilterBlockOpenByMouse);
    const isOpenByButton = useSelector((state) => state.navigationReducer.isFilterBlockOpenByBtn);
    const isOpen = isOpenByHover || isOpenByButton;

    const setPersistedOpen = useCallback((isOpened, {persist = true} = {}) => {
        dispatch({type: TOGGLE_OPEN_FILTER_BLOCK_BY_BUTTON, payload: isOpened});

        if (!persist) {
            return;
        }

        setToLocalStorage(
            LOCAL_STORAGE_IS_FILTERS_OPEN,
            {value: isOpened},
            STORAGE_PERIOD_IN_HOURS
        );
    }, [dispatch]);

    const togglePersistedOpen = useCallback(() => {
        setPersistedOpen(!isOpen);
    }, [isOpen, setPersistedOpen]);

    const setTemporaryOpen = useCallback((isOpened) => {
        dispatch({type: TOGGLE_OPEN_FILTER_BLOCK_BY_MOUSE, payload: isOpened});
    }, [dispatch]);

    const restorePersistedOpen = useCallback(({defaultOpen = true, allowPersistedState = true} = {}) => {
        const savedFiltersState = getFromLocalStorage(LOCAL_STORAGE_IS_FILTERS_OPEN);
        const nextOpenState = allowPersistedState
            ? (savedFiltersState ? savedFiltersState.value : defaultOpen)
            : false;

        setPersistedOpen(nextOpenState, {persist: false});

        return nextOpenState;
    }, [setPersistedOpen]);

    return {
        isOpen,
        isOpenByHover,
        isOpenByButton,
        setPersistedOpen,
        togglePersistedOpen,
        setTemporaryOpen,
        restorePersistedOpen,
    };
}
